import './index.css';

function TvPlanStep({ index, last, title, des, children }) {
    return (
    	<div className="tv-plan-step">
            <div className="tv-plan-step-dot">{parseInt(index)||1}</div>
            {!last && (
                <div className="tv-plan-step-line"></div>
            )}
            <div className="tv-plan-step-title">{title}</div>
            <div className="tv-plan-step-des">{des}</div>
            <div className="tv-plan-step-content">{children}</div>
    	</div>
    );
}

export default TvPlanStep;
